/* global axios */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  createStage(pipelineId, data) {
    return axios.post(`${this.url}/${pipelineId}/stages`, data);
  }

  updateStage(pipelineId, stageId, data) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, data);
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }

  reorderStages(pipelineId, stageIds) {
    return axios.post(`${this.url}/${pipelineId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }
}

class DealsAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  getDeals(params = {}) {
    return axios.get(this.url, { params });
  }

  updateStage(dealId, stageId, pipelineId = null) {
    const payload = { stage_id: stageId };
    if (pipelineId) {
      payload.pipeline_id = pipelineId;
    }
    return axios.patch(`${this.url}/${dealId}/update_stage`, payload);
  }
}

export const pipelinesAPI = new PipelinesAPI();
export const dealsAPI = new DealsAPI();
export default {
  pipelines: pipelinesAPI,
  deals: dealsAPI,
};
